import type { Tracklist } from "@api/tracklists/types";
import { getProfileFeed } from "@api/user";
import { createEffect, createSignal, on, useContext } from "solid-js";
import { produce } from "solid-js/store";
import { playerContext } from "../..";
import type { PlayerTrack } from "../../types";

const useLiveMode = () => {
	const { player, setPlayer } = useContext(playerContext);
	const [lastTracklist, setLastTracklist] = createSignal<Tracklist["uuid"]>();
	createEffect(
		on(
			() => player.track,
			(t) => {
				const uuid = player.queue[t]?.tracklistUuid;
				if (player.feed.type !== "USER" || !uuid) return;
				if (lastTracklist() === uuid) return;

				getProfileFeed(player.feed.uid).then((res) => {
					let index = res.findIndex((i) => i.uuid === uuid);
					if (index === -1) index = res.length;
					const toBeAdded = res.slice(0, 0);
					setPlayer(
						"queue",
						produce((queue) => {
							const tracks = toBeAdded.flatMap((tracklist) =>
								tracklist.tracks.map<PlayerTrack>((tr, trackIndex) => ({
									track: tr,
									tracklistUuid: tracklist.uuid,
									index: trackIndex,
									type: "TRACK",
									author: tracklist.author.nickname,
									id: tr.id,
									name: tr.name,
									photo: tr.photo,
									platform: tr.platform,
								})),
							);
							queue = [...queue.slice(0, t), ...tracks, ...queue.slice(t + 1)];
							return queue;
						}),
					);
				});
				setLastTracklist(uuid);
			},
		),
	);
};
export default useLiveMode;
